import { useState, } from "react";
import { Modal, Table, Select, Button, Form, notification } from "antd";
import ProjectLookup from "../../common/ProjectLookup";
import { textRender } from "../../../utils";
import { deviceTransfer } from "../../../api/device";

const { Column } = Table;
export default function TransferModal({
    showTransferModal,
    setShowTransferModal,
    selectedRows,
    originMac,
    onDone
}: {
    showTransferModal?: boolean,
    setShowTransferModal: Function,
    selectedRows: Device[],
    originMac: string,
    onDone: Function,
}) {
    const [project, setProject] = useState<Project>();
    const [form] = Form.useForm();
    const [submitting, setSubmitting] = useState(false);
    return (
        <Modal
            title='设备迁移'
            width={'80%'}
            footer={null}
            open={showTransferModal}
            destroyOnClose
            onCancel={() => setShowTransferModal(false)}
        >
            <div>
                <h4>已选设备:</h4>
                <Table dataSource={selectedRows} pagination={false}>
                    <Column title="设备序列号" dataIndex="deviceSn" key="deviceSn" />
                    <Column title="ICCID" render={textRender} dataIndex="iccid" key="iccid" />
                    <Column title="网关" render={textRender} dataIndex="mac" key="mac" />
                    <Column title="展位号" render={textRender} dataIndex="name" key="name" />
                    <Column title="网络类型" dataIndex="type" key="type" />
                </Table>
                <h4>迁移至:</h4>
                <Form form={form} style={{ width: 300 }}>
                    <Form.Item name='projectId' label='展会' rules={[{ required: true }]}>
                        <ProjectLookup onChange={(_, project) => {
                            setProject(project as unknown as Project)
                        }} />
                    </Form.Item>
                    <Form.Item name='newMac' label='网关' rules={[{ required: true }]}>
                        <Select options={project?.gateways?.map(i => {
                            return {
                                label: i.name, value: i.mac
                            }
                        })} />
                    </Form.Item>
                </Form>
            </div>
            <div style={{ textAlign: 'center' }}>
                <Button loading={submitting} type="primary" onClick={() => {
                    form.validateFields()
                        .then((values: any) => {
                            setSubmitting(true);
                            deviceTransfer({
                                "deviceSnList": selectedRows.map(i => i.deviceSn),
                                "projectId": values.projectId,
                                "request": {
                                    "newMac": values.newMac,
                                    "originMac": originMac
                                }
                            })
                            .then(() => {
                                onDone()
                                setSubmitting(false)
                            })
                            .catch((err: Error) => {
                                notification.error({message: err.message || '迁移失败,请重试'})
                                setSubmitting(false)
                            })
                        })
                        .catch(() => { })
                }}>确认迁移</Button>
            </div>
        </Modal>
    )
}